import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCode, FiExternalLink } = FiIcons;

const DeveloperFooter = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="border-t border-gray-800 p-4"
    >
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-center space-x-2 text-gray-500 text-sm">
          <SafeIcon icon={FiCode} className="w-4 h-4" />
          <span>Developed by</span>
          <a
            href="https://shawnryder.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-audi-red hover:text-red-400 font-medium transition-colors flex items-center space-x-1"
          >
            <span>Shawn Ryder</span>
            <SafeIcon icon={FiExternalLink} className="w-3 h-3" />
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default DeveloperFooter;